<template>
  <div v-if="item">
    <div class="border">
      <selector
        ref="shop_init"
        @input="updateItemData(['status'], 'status')"
        :title="`Статус заказа`"
        :titleKey="`select_status`"
        :prefix="`status`"
        :modal="`status`"
        :selectKey="`name`"
        v-model="item.status"
      />
      <h3 v-if="item.product_name">
        <b class="text-danger">{{ item.product_name }}</b>
      </h3>
      <h6 v-if="item.plan">
        {{ "plan" | setText("Тарифный план") }}:
        <span class="text-info">{{ item.plan }}</span>
      </h6>
      <h6 v-if="item.user_phone">
        {{ "phone" | setText("Текущий номер телефона") }}:
        <span class="text-success">{{ item.user_phone }}</span>
      </h6>
      <h6 v-if="item.product_barcode">
        {{ "barcode" | setText("Баркод") }}: {{ item.product_barcode }}
      </h6>
      <h6 v-if="item.product_price">
        {{ "price" | setText("Цена") }}:
        {{ item.product_price | spaceBetweenNumber }} UZS
      </h6>
      <h6 v-if="item.loan_amount">
        {{ "loan_amount" | setText("Сумма страховки") }}:
        {{ item.loan_amount | spaceBetweenNumber }} UZS
      </h6>
      <h6 v-if="item.loan_period">
        {{ "period" | setText("Период") }}:
        {{ item.loan_period | spaceBetweenNumber }}
        {{ "mo" | setText }}
      </h6>
      <h6>
        {{ "start_paid_at" | setText("Дата начала оплаты") }}:
        {{ item.start_date | dateFormat }}
      </h6>
      <h6 v-if="item.end_date">
        {{ "end_paid_at" | setText("Дата окончания оплаты") }}:
        {{ item.end_date | dateFormat }}
      </h6>
      <h6
        v-if="
          item.user_last_name && item.user_first_name && item.user_family_name
        "
      >
        {{ "client" | setText("Покупатель") }}: {{ item.user_first_name }}
        {{ item.user_last_name }} {{ item.user_family_name }}
      </h6>
      <h6 v-if="item.user_passport">
        {{ "client_passport" | setText("Паспорт") }}: {{ item.user_passport }}
      </h6>
      <h6 v-if="item.user_pinfl">
        {{ "client_pinfl" | setText("ПИНФЛ") }}: {{ item.user_pinfl }}
      </h6>
    </div>

    <div v-if="item.state === 'init'">
      <div :class="`mt-4 ${item.state === 'init' ? '' : 'opacity'}`">
        <limit
          :price_fix="item.service.price_fix"
          :subscription_id="item.id"
          :limited_at="item.limited_at"
          :phone="item.user_phone"
          v-model="item"
          @input="updateItemData(['limit', 'limit_preview'])"
        />
      </div>
    </div>
    <div v-else-if="item.state === 'update'">
      <fields-list :item="item" :fields="fields" />
      <div class="save-group">
        <button class="btn btn-info btn-icon" @click="infoupdateItemData">
          <span class="ti-save"></span>{{ "next" | setText("Далее") }}
        </button>
      </div>
    </div>
    <div v-else>
      <div class="row">
        <div
          :class="`col-12 col-lg-12  ${
            item.state !== 'new' || item.limit_status !== 'success'
              ? 'opacity'
              : ''
          }`"
        >
          <div class="border">
            <phone-control
              v-model="item"
              @input="
                updateItemData(
                  ['phone_control', 'blank_number', 'blank_date'],
                  'phone'
                )
              "
            />
          </div>
        </div>
        <div
          :class="`col-12 col-lg-12  ${
            item.state !== 'new' || !item.phone_control ? 'opacity' : ''
          }`"
        >
          <div class="border">
            <h4>
              2. {{ "add_imei" | setText("Добавить IMEI ") }}
              <span
                v-if="item.imeis && item.imeis.length"
                class="ti-check text-success"
              ></span>
              <info :id="1" />
            </h4>
            <imeis-list
              :barcode="item.product_barcode"
              v-model="item.imeis"
              @input="updateItemData(['imeis'], 'imei')"
            />
          </div>
        </div>
      </div>

      <!-- BSS SERVICE -->
      <div
        :class="`border ${
          item.state === 'cancel' ||
          item.imeis.length === 0 ||
          !item.phone_control
            ? 'opacity'
            : ''
        }`"
      >
        <h4>
          3. {{ "add_control_uzimei" | setText("Установка на контроль") }}
          <span
            v-if="item.state == 'done'"
            class="ti-check text-success"
          ></span>
        </h4>
        <div class="mb-3">
          <h6>IMEI:</h6>
          <p v-for="(imei, k) in item.imeis" :key="k">
            IMEI {{ k + 1 }}: {{ imei.number }}
          </p>
        </div>
        <div class="mb-3">
          <h6>MSISDN:</h6>
          <p>{{ item.phone_control }}</p>
        </div>
        <div class="mb-3">
          <h6>{{ "product" | setText("Товар") }}:</h6>
          <p>{{ item.product_name }}</p>
        </div>

        {{ item.state }}
        <component
          v-if="item && item.service"
          :is="item.service.code"
          :data="item"
          type="subscription"
          v-model="valueData"
          @input="serviceupdateItemData"
          @update="serviceupdateItemData"
        />
      </div>

      <!-- Semurg -->
      <div :class="`border ${item.state !== 'done' ? 'opacity' : ''}`">
        <h4>
          4. {{ "add_insurance" | setText("Оформить страховку") }}
          <span
            v-if="
              item.service_requests &&
              item.service_requests.length &&
              item.service_requests.filter((i) => i.state === 'done').length
            "
            class="ti-check text-success"
          ></span>
        </h4>
        <h6>
          <b class="text-danger">{{ item.product_name }}</b>
        </h6>
        <h6>
          {{ "price" | setText("Цена") }}:
          {{ item.product_price | spaceBetweenNumber }} UZS
        </h6>
        <h6>
          {{ "loan_amount" | setText("Сумма страховки") }}:
          {{ item.loan_amount | spaceBetweenNumber }} UZS
        </h6>
        <semurg
          :data="item"
          v-model="valueData"
          @input="serviceupdateItemData"
          @update="updateItemData"
          :type="'subscription'"
        />
      </div>
      <!-- Договор -->
      <div
        :class="`border ${
          item.state !== 'done' ||
          !item.service_requests.filter((i) => i.state === 'done').length
            ? 'opacity'
            : ''
        }`"
      >
        <h4>
          5. {{ "sign_order" | setText("Подписать договор") }}
          <span v-if="item['sign']" class="ti-check text-success"></span>
        </h4>
        <doc
          :doc="`${$store.state.host}/api/v1/pdf/subscriptions/${item.id}`"
          v-model="item['sign_upload']"
          :sign="item['sign']"
          @input="updateItemData(['sign_upload'], 'upload')"
        />

        <!-- ADDDED -->
        <hr />
        <!-- <doc-affert-document
          :doc="`${$store.state.host}/api/v1/pdf/subscriptions/${item.id}`"
          v-model="item['affert_document']"
          :file="item['affert_document']"
          @input="updateItemData(['affert_document'], 'upload')"
        />
        <hr /> -->
        <doc-passport-copy
          :doc="`${$store.state.host}/api/v1/pdf/subscriptions/${item.id}`"
          v-model="item['passport_copy']"
          :file="item['passport_copy']"
          @input="updateItemData(['passport_copy'], 'upload')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  cardContent,
  toFormData,
  errorNotify,
  cardUpdate,
} from "@/plugins/functions";
import { logger } from "../../../plugins/functions";

export default {
  components: {
    bss: () => import("@/components/Services/bss"),
    "imeis-list": () => import("./ImeisList"),
    semurg: () => import("@/components/Services/semurg"),
    doc: () => import("./Doc"),
    DocAffertDocument: () => import("./DocAffertDocument"),
    DocPassportCopy: () => import("./DocPassportCopy"),
    "phone-control": () => import("./PhoneControl"),
    limit: () => import("@/components/Limit"),
  },
  data: () => ({
    cardLink: "subscriptions",
    cardSetLink: "subscriptions",
    item: null,
    valueData: {},
    fields: [
      {
        col: "col-12 col-md-6",
        label: "Имя клиента",
        key: "user_first_name",
        labelKey: "first_name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Фамилия клиента",
        key: "user_last_name",
        labelKey: "last_name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Отчество клиента",
        key: "user_family_name",
        labelKey: "family_name",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "ПИНФЛ",
        key: "user_pinfl",
        labelKey: "PINFL",
        type: "field",
        info: 2,
      },
      {
        col: "col-12 col-md-6",
        label: "Номер паспорта",
        key: "user_passport",
        labelKey: "passport_number",
        type: "field",
      },
      {
        col: "col-12 col-md-12",
        label: "Адрес прописки в паспорте",
        key: "user_address",
        labelKey: "passport_address",
        type: "field",
      },
      {
        col: "col-12 col-md-6",
        label: "Дата рождения",
        key: "user_birthday",
        labelKey: "birthday",
        type: "field",
        textType: "date",
      },
      {
        col: "col-12",
        label: "Пол",
        key: "user_gender",
        labelKey: "gender",
        type: "static_radio",
        default: "1",
        items: [
          { id: "1", title: "Мужской" },
          { id: "0", title: "Женский" },
        ],
      },
      {
        label: "Тариф",
        key: "tariff",
        labelKey: "tariff",
        type: "select",
        modal: "tariff",
        selectKey: "name",
        params: {
          service_code: "bss",
        },
      },
      {
        label: "Товар",
        key: "variant",
        labelKey: "product",
        type: "select",
        modal: "variant",
        selectKey: "name",
        needKey: "tariff",
        params: {},
        toParametr: {
          key: "tariff",
          parametr: "tariff_id",
        },
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async infoupdateItemData() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item) {
        setTimeout(() => {
          this.item = JSON.parse(JSON.stringify(item));

          logger(this.$http, {
            name: `Добавлены данные клиента`,
            description: "ФИО, ПИНФЛ, пасспорт, адрес, дата рождения, пол",
            model_type: "subscription",
            model_id: this.id,
          });
        }, 10);
      }
    },

    async serviceupdateItemData() {
      setTimeout(() => {
        this.$loading(true);
      }, 1);

      return this.$http({
        method: "post",
        data: toFormData({ _method: "put", ...this.valueData }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$store.dispatch("setLastUpdate", new Date());
          this.item = response.data.data;
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 200);
        });
    },

    async updateItemData(keys = [], typeRequest = "") {
      let data = {};
      let tempData = this.item;

      for (let i = 0; i < keys.length; i++) {
        data[keys[i]] = tempData[keys[i]];
      }

      setTimeout(() => {
        this.$loading(true);
      }, 1);

      this.$http({
        method: "post",
        data: toFormData({
          _method: "put",
          ...data,
        }),
        url: `${this.cardLink}/${this.id}`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          this.$notify({
            title: "Успешно",
            message: "Вы успешно применили данные",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          this.$store.dispatch("setLastUpdate", new Date());
          this.item = response.data.data;

          if (typeRequest === "phone") {
            logger(this.$http, {
              name: `Установка номера телефона и номера бланка`,
              description: typeRequest,
              model_type: "subscription",
              model_id: this.id,
            });
          } else if (typeRequest === "imei") {
            logger(this.$http, {
              name: `Установка IMEI`,
              description: typeRequest,
              model_type: "subscription",
              model_id: this.id,
            });
          } else if (typeRequest === "upload") {
            logger(this.$http, {
              name: `Загрузка договора`,
              description: typeRequest,
              model_type: "subscription",
              model_id: this.id,
            });
          } else if (typeRequest === "status") {
            logger(this.$http, {
              name: `Изменение статуса`,
              description: typeRequest,
              model_type: "subscription",
              model_id: this.id,
            });
          }
        })
        .catch((error) => {
          return errorNotify(error, this.notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 100);
        });
    },
  },
};
</script>
